import { render, staticRenderFns } from "./edit-edro.vue?vue&type=template&id=55fb92ef&scoped=true&"
import script from "./edit-edro.vue?vue&type=script&lang=js&"
export * from "./edit-edro.vue?vue&type=script&lang=js&"
import style0 from "./edit-edro.vue?vue&type=style&index=0&id=55fb92ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb92ef",
  null
  
)

component.options.__file = "edit-edro.vue"
export default component.exports